import { jwtDecode as jwt } from "jwt-decode";
import type { IRoleConfig } from "../services/entities/SettingEntity";
import type { Roles } from "../services/enums/SettingEnum";
export interface IRBACRole {
  AccessPages: string[];
  AccessControls: IRoleConfig | any;
}
export const isVisibleComponetBaseOnRole = (roles?:string[], requireRoles?:string[]):boolean => {
  // case public (component always visible)
  if (!requireRoles ||  !requireRoles.length ) {
    return true
  } else if(!roles || !roles.length) {
    return false
  } else {
    return requireRoles.some(require => roles.some(role => role?.includes(require)));
  }
}


const mapRoleByString = (str: string): Roles => {
  return str as Roles;
};

const PageOfContext: { [x: string]: string[] } = {
  Organization: ["organization", "orgId"],
  Location: ["organization", "orgId"],
  Category: ["organization", "orgId"],
  Tenant: ["tenant"],
  Sensor: ["sensor"],
  Calendar: ["calendar"],
};


export const onHandleTokenToGetRoles = (token: string) => {
  const test: IRBACRole = {
    AccessPages: [],
    AccessControls: {},
  };
  if (token.trim() === "") {
    return test;
  }
  const tokenDecode: any = jwt(token);
  if (
    tokenDecode &&
    tokenDecode.role &&
    Array.isArray(tokenDecode.role) &&
    tokenDecode.role.length > 0
  ) {
    tokenDecode.role.map((i: string) => {
      const [r, ...seedRole] = i.split(".");
      const roleMerge = seedRole.join(".");
      const arr = [r, roleMerge];
      const context = arr[0] || "";
      const role = mapRoleByString(arr[1]);
      let roleAll: Roles | null = null;
      if (arr[2]) {
        roleAll = mapRoleByString(`${arr[1]}.${arr[2]}`);
      }
      const pages = PageOfContext[context] || [];
      test.AccessPages = [...test.AccessPages, ...pages];
      if (test.AccessControls[context] === undefined) {
        test.AccessControls = {
          ...test.AccessControls,
          [context]:
            roleAll && roleAll.includes("All") ? [role, roleAll] : [role],
        };
      } else {
        test.AccessControls[context] =
          roleAll && roleAll.includes("All")
            ? [...test.AccessControls[context], role, roleAll]
            : [...test.AccessControls[context], role];
      }
    });
    return test;
  }
  if (tokenDecode && tokenDecode.role && typeof tokenDecode.role === "string") {
    const [r, ...seedRole] = tokenDecode.role.split(".");
    const roleMerge = seedRole.join(".");
    const arr = [r, roleMerge];
    const context = arr[0] || "";
    const role = mapRoleByString(arr[1]);
    const pages = PageOfContext[context] || [];
    test.AccessPages = [...test.AccessPages, ...pages];
    test.AccessControls = { ...test.AccessControls, [context]: [role] };
    return test;
  }
  return test;
};